import DOMPurify from 'dompurify';
import React, { useEffect } from 'react';
import { privacyPolicy } from '../../privacyPolicy';
import { Box } from '@mui/material';
import { useGTM } from '../../hooks/useGTM';

export const PrivacyPolicy = () => {
  const { pageView } = useGTM();
  useEffect(() => {
    pageView('/privacyPolicy');
  }, []);
  return (
    <Box
      sx={{ padding: '20px', marginLeft: '20px', marginRight: '20px' }}
      dangerouslySetInnerHTML={{
        __html: DOMPurify.sanitize(privacyPolicy),
      }}
    />
  );
};
